import {
    TRAIL_DELETED, TRAIL_DELETING,
    TRAIL_DOWNLOADED, TRAIL_EDITING, TRAIL_FAILED, TRAIL_FOCUS,
    TRAIL_MEDIA_DELETED, TRAIL_MEDIA_DELETING, TRAIL_MEDIA_FAILED, TRAIL_MEDIA_FOCUS,
    TRAIL_MEDIA_UPLOADED, TRAIL_MEDIA_UPLOADING, TRAIL_POSTING,
    TRAIL_RESET, TRAILS_DOWNLOADED, TRAILS_FAILED,
    TRAILS_PENDING, TRAILS_RESET
} from "./types";
import LangService from '../../services/lang';

export const INITIAL_STATE = {
    error: null,
    content: LangService.defaultTranslatedContent,
    deletingMedia: false,
    pending: false,
    sending: false,
    currentIndex: null,
    currentTrail: null,
    currentMedia: null,
    pendingMedias: [],
    uploadedMedias: [],
    failedMedias: []
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case TRAILS_RESET:
            return INITIAL_STATE;
        case TRAIL_RESET:
            return {
                ...state,
                error: null,
                sending: false,
                currentIndex: 0,
                currentTrail: null
            };
        case TRAIL_FOCUS:
            return {
                ...state,
                error: null,
                currentIndex: state.content[action.payload.lang].findIndex(trail => {
                    return trail.id === action.payload.trail.id
                }),
                currentTrail: action.payload.trail
            };
        case TRAIL_POSTING:
            return {
                ...state,
                sending: true
            };
        case TRAIL_DOWNLOADED:
            let newIndex;
            let id = action.payload.trail.id;
            let trail = state.content[action.payload.lang].find(function (trail) {
                return trail.id === id
            });

            let newContent = {...state.content};
            if (trail) {
                let index = state.content[action.payload.lang].findIndex(stateTrail => {
                    return stateTrail.id === trail.id
                });
                newContent[action.payload.lang][index] = action.payload.trail;
                newIndex = index;
            } else {
                newContent[action.payload.lang] = [
                    ...state.content[action.payload.lang],
                    action.payload.trail
                ];
                newIndex = newContent[action.payload.lang].length - 1;
            }

            return {
                ...state,
                pending: false,
                sending: false,
                error: null,
                content: newContent,
                currentTrail: action.payload.trail,
                currentIndex: newIndex
            };
        case TRAIL_FAILED:
            return {
                ...state,
                deletingMedia: false,
                pending: false,
                sending: false,
                error: action.payload,
                currentTrail: null,
                currentIndex: 0
            };
        case TRAILS_PENDING:
            return {
                ...state,
                pending: true
            };
        case TRAIL_EDITING:
            return {
                ...state,
                sending: true
            };
        case TRAILS_DOWNLOADED:
            let newContentTrail = {...state.content};
            newContentTrail[action.payload.lang] = action.payload.trails;
            let newCurrentTrail = null;
            if (state.currentTrail) {
                let index = newContentTrail[action.payload.lang].findIndex(stateTrail => {
                    return stateTrail.id === state.currentTrail.id;
                });
                newCurrentTrail = newContentTrail[action.payload.lang][index];
            }
            return {
                ...state,
                pending: false,
                sending: false,
                error: null,
                content: newContentTrail,
                currentTrail: newCurrentTrail
            };
        case TRAILS_FAILED:
            return {
                ...state,
                pending: false,
                error: action.payload
            };
        case TRAIL_DELETED:
            let newState = {
                ...state,
                sending: false
            };

            LangService.langs.forEach(function (l) {
                if (newState.content[l.key] !== undefined) {
                    newState.content[l.key] = state.content[l.key].filter((trail) => {
                        return trail.id !== action.payload.id;
                    });
                }
            });

            if (state.currentTrail) {
                if (state.currentTrail.id === action.payload.id) {
                    newState.currentTrail = null;
                    newState.currentIndex = null;
                } else {
                    newState.currentIndex = newState.content[action.payload.lang].findIndex((trail) => {
                        return newState.currentTrail.id === trail.id
                    });
                }
            }

            return newState;
        case TRAIL_DELETING:
            return {
                ...state,
                sending: true
            };
        case TRAIL_MEDIA_FOCUS:
            return {
                ...state,
                error: null,
                pending: false,
                currentMedia: action.payload
            };
        case TRAIL_MEDIA_UPLOADING:
            return {
                ...state,
                pendingMedias: [
                    ...state.pendingMedias,
                    action.payload
                ],
                sending: true
            };
        case TRAIL_MEDIA_UPLOADED:
            return {
                ...state,
                pendingMedias: state.pendingMedias.filter((media) => {
                    return media !== action.payload
                }),
                uploadedMedias: [
                    ...state.uploadedMedias,
                    action.payload
                ],
                sending: false,
                currentMedia: action.payload
            };
        case TRAIL_MEDIA_FAILED:
            return {
                ...state,
                pendingMedias: state.pendingMedias.filter((media) => {
                    return media !== action.payload
                }),
                failedMedias: [
                    ...state.failedMedias,
                    action.payload
                ],
                currentMedia: action.payload
            };
        case TRAIL_MEDIA_DELETING:
            return {
                ...state,
                deletingMedia: true
            };
        case TRAIL_MEDIA_DELETED:
            const trailMediaDeleted = {...state.currentTrail};
            trailMediaDeleted.medias = trailMediaDeleted.medias.filter((media) => media.id !== action.payload);

            return {
                ...state,
                deletingMedia: false,
                currentTrail: trailMediaDeleted,
                currentMedia: null
            };
        default:
            break;
    }

    return state;
}



// WEBPACK FOOTER //
// src/store/trails/reducers.js